import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios'; // Import axios for API call
import BottomNav from "../../component/BottomNav";
import { API_URL } from "../../common/constant";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { FaCheckCircle } from 'react-icons/fa';
import Loader from "../../component/loader/Loader";
import FAQ from "../../component/FAQ/FAQ";
import Appartment_rent from "../../component/Appartment_rent_in_society/Appartment_rent_in_society";

const ProjectDetails = () => {
    const phoneNumber = "8318150076";
    const { id } = useParams();
    const [projectDetails, setProjectDetails] = useState(null); // State to hold the fetched project details
    const [selectedImage, setSelectedImage] = useState('');
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch project details by ID from the backend
    console.log("idd", id)
    useEffect(() => {
        const fetchProjectDetails = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/society-rent/get-rent-society/${id}`);
                console.log("api check", response?.data)
                if (response?.data) {
                    console.log("dta=>", response?.data)
                    console.log("img", response?.data?.otherImages)
                    setProjectDetails(response?.data);



                    setImages([response?.data?.mainImage, ...response?.data?.otherImages]);

                    setSelectedImage(response?.data?.mainImage);
                    setLoading(false)
                }
            } catch (error) {
                console.error("Error fetching project details", error);
            }
        };

        fetchProjectDetails();
        window.scrollTo(0, 0);
    }, [id]);
const [properties, setProperty] = useState([]);
       
        const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPropertyDetails = async () => {
            console.log("iddddd==>",id)
            try {
                const response = await axios.get(`${API_URL}/api/rentApartment/society/${id}`);
                console.log( "response======>",response.data.society)
                
                if (response.data?.society) {
                    console.log("res==--->", response.data);
                    console.log("res=====>", response.data.society);
                
                    // Ensure society is always an array
                    const societyData = Array.isArray(response.data.rentApartments)
                        ? response.data.rentApartments
                        : [response.data.rentApartments];
                
                    setProperty(societyData);
                    setSelectedImage(response.data?.mainImage);
                } else {
                    setProperty([]);
                }
                
            } catch (error) {
                setError("Failed to fetch rent details");
                console.error("Error fetching rent details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPropertyDetails();
    }, [id]);
    // console.log("project", projectDetails)
    if (loading) {
        return <Loader />;
    }

    console.log('society detail==>', projectDetails)
    // console.log('images==>', images)


    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <div className=" rounded-lg p-4 ">
                <div className="flex flex-col lg:flex-row">
                    {/* Left Side: Project Overview */}
                    <div className="lg:w-1/2">
                        {/* Image Review Section */}
                        <div>
                            {/* Main Image Preview */}
                            <img
                                // src={`${API_URL}/uploads/societies/${id}/${selectedImage}`}
                                src={`${API_URL}/uploads/societyRent/${id}/${selectedImage}`}
                                alt={`Available for rent`}
                                className="w-full h-64 md:h-96 rounded-lg object-cover"
                            />
                            <div className="flex space-x-4 mt-4 overflow-x-auto">

                                {images.map((image, index) => (
                                    <>
                                        {console.log(`${API_URL}/uploads/societyRent/${id}/${image}`)}

                                        <img
                                            key={index}
                                            src={`${API_URL}/uploads/societyRent/${id}/${image}`}
                                            alt={`Available for rent`}
                                            className={`w-16 h-16 md:w-20 md:h-20 object-cover rounded-lg cursor-pointer ${selectedImage === image
                                                ? "border-4 border-[#54BD95]"
                                                : "border"
                                                }`}
                                            onClick={() => setSelectedImage(image)}
                                        />
                                    </>
                                ))}
                            </div>
                        </div>

                        {/* Project Overview */}
                        <div className="mt-4">
                            <h1 className="text-xl md:text-2xl font-bold text-gray-800">
                                {projectDetails.name}
                            </h1>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                                {/* <div>
                                    <p className="text-sm text-gray-500">Total Project Area</p>
                                    <p className="text-lg font-semibold">{projectDetails.area}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Total Units</p>
                                    <p className="text-lg font-semibold">
                                        {(
                                            (projectDetails.one_bhk_unit ? parseInt(projectDetails.one_bhk_unit) : 0) +
                                            (projectDetails.two_bhk_unit ? parseInt(projectDetails.two_bhk_unit) : 0) +
                                            (projectDetails.three_bhk_unit ? parseInt(projectDetails.three_bhk_unit) : 0) +
                                            (projectDetails.four_bhk_unit ? parseInt(projectDetails.four_bhk_unit) : 0)
                                        )} Units
                                    </p>

                                </div> */}
                                <div>
                                    <p className="text-sm text-gray-500">BHK</p>
                                    <p className="text-lg font-semibold">
                                        <p>Starting from 1 BHK</p>
                                        {/* {
                                            (parseInt(projectDetails.one_bhk_unit) > 0 ? '1 BHK, ' : '') +
                                            (parseInt(projectDetails.two_bhk_unit) > 0 ? '2 BHK, ' : '') +
                                            (parseInt(projectDetails.three_bhk_unit) > 0 ? '3 BHK, ' : '') +
                                            (parseInt(projectDetails.four_bhk_unit) > 0 ? '4 BHK' : '')
                                        } */}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Price Range</p>
                                    <p className="text-lg font-semibold">{projectDetails.one_bhk_rent}-{projectDetails.three_bhk_rent}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Property Type</p>
                                    <p className="text-lg font-semibold">Apartment</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Unit Configuration */}
                    <div className="lg:w-1/2 lg:pl-6 mt-6 lg:mt-0">
                        <h2 className="text-xl text-start font-semibold text-gray-800 mb-4">
                            Unit Configuration
                        </h2>
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr>
                                    <th className="border-b p-2 text-gray-600">Unit Type</th>
                                    <th className="border-b p-2 text-gray-600">

                                    </th>
                                    <th className="border-b p-2 text-gray-600">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[{ type: "1 BHK", price: "₹" + projectDetails.one_bhk_rent },
                                { type: "2 BHK", price: "₹" + projectDetails.two_bhk_rent },
                                { type: "3 BHK", price: "₹" + projectDetails.three_bhk_rent },
                                    // { type: "4 BHK",  price: "₹" + projectDetails.four_bhk_rent  }
                                ]
                                    .map((unit, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="border-b p-2">{unit.type}</td>
                                            <td className="border-b p-2">{unit.area}</td>
                                            <td className="border-b p-2">{unit.price}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>

                        {/* Facilities */}
                        <div className="mt-8">
                            <h2 className="text-xl text-start font-semibold text-gray-800 mb-4">
                                Facilities
                            </h2>
                            <div className="grid grid-cols-3 gap-6 text-gray-700">
                                {/* Display each facility as a separate grid item */}
                                {projectDetails.facilities.map((facility, index) => (
                                    <div key={index} className="space-y-2">
                                        {/* Display icon and facility text */}
                                        <div className="flex items-center space-x-2">
                                            <FaCheckCircle className="text-[#54BD95]" size={20} /> {/* Common icon */}
                                            <p className="text-sm sm:text-base">{facility}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mt-8">
                            <h2 className="text-xl text-start font-semibold text-gray-800 mb-4">
                                Description
                            </h2>
                            <div className=" text-gray-700">
                                {/* Display each facility as a separate grid item */}
                                <div className="space-y-2">
                                    <p>{`${projectDetails.name} – A well-established and well-maintained society, ${projectDetails.name} offers spacious living spaces with a variety of amenities. This society features wide roads, landscaped parks, 24/7 security, parking facilities, and power backup. Residents enjoy easy access to schools, markets, hospitals, and public transport. Additional amenities include recreational areas, sports facilities, and much more. Perfect for families and professionals alike.`}</p>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div className="mt-14 mx-4 flex justify-start">
                                <div className="bg-white shadow-lg rounded-2xl p-4 w-full max-w-sm border border-gray-200">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">Get in Touch</h3>
                                    <div className="flex flex-col items-center">
                                        <a
                                            href={`tel:${phoneNumber}`}
                                            className="flex items-center justify-center w-full bg-[#54BD95] text-white px-4 py-3 rounded-lg text-md hover:bg-[#45a282] transition-all duration-200"
                                        >
                                            <FaPhoneAlt className="text-white mr-2" size={18} />
                                            <span className="text-white text-md">Contact Us</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>





                    </div>
                </div>
                <div className="mt-24">
                 <h2 className="text-4xl mx-20   text-[#54BD95] mb-4">
                       Available Flats for Rent 
                     </h2>
                <Appartment_rent properties={properties} loading={loading} error={error} />
                </div>
                
                {/* Location Section */}
                <div className="bg-white shadow-md rounded-lg p-6 mt-6">
                    <h2 className="text-xl font-semibold text-start text-gray-800 mb-4">Location</h2>
                    <div className="relative">
                        <iframe
                            src={projectDetails.mapLocation}
                            width="100%"
                            height="350"

                            allowfullscreen=""
                            loading="lazy"
                            title="Lucknow Map"
                            class="rounded-lg w-full cursor-pointer"
                        ></iframe>


                    </div>
                </div>
            </div>
            {/* <div className='w-full'>
                <FAQ/>
                </div> */}

            <BottomNav />
        </div>
    );

};

export default ProjectDetails;
